<template>
    <section id="checkout-thanks-timeline">
        <div class="row mt-5">
            <div class="col-12">
                <h3>{{$t('co.final.timeline.title')}}</h3>
            </div>
        </div>

        <checkout-thanks-information v-if="this.$root.whitelabel.isUs()"></checkout-thanks-information>

        <div class="row">
            <div class="col-12">
                <timeline>
                    <li v-if="this.$root.whitelabel.isUs()">{{$t('co.final.timeline.verify_equifax')}}</li>
                    <li>{{$t('co.final.timeline.booking_check')}}</li>
                    <li>{{$t('co.final.timeline.partner_contact')}}</li>
                    <li>{{$t('co.final.timeline.vehicle_preparation')}}</li>
                    <li v-if="!this.$root.whitelabel.isUs()">{{$t('co.final.timeline.handover')}}</li>
                </timeline>
            </div>
        </div>
    </section>
</template>

<script>
import CheckoutLayout from '../../layouts/CheckoutLayout.vue'
import Timeline from '../molecules/Timeline.vue'
import CheckoutThanksInformation from './CheckoutThanksInformation.vue'

export default {
    name: 'CheckoutThanksTimeline',
    components: {
        CheckoutThanksInformation,
        CheckoutLayout,
        Timeline
    },
    computed: {

    }
}
</script>
<style scoped lang="scss">
.timeline li {
    padding-top: 20px;
}
</style>
